import React from 'react';
import {
  Chip,
  Stack,
  Tooltip,
} from '@mui/material';
import { ZSpinner } from '@marageti/z4-lib';
import { getFailureReasonLabel } from './helpers';
import { FailureReasonChip, ScreeningCriteriaMap } from './types';

type CriteriaListProps = {
  screeningCriteriaMap?: ScreeningCriteriaMap;
  canEdit: boolean;
  isCorrectionLoading: boolean;
  isSaving: boolean;
  reasons: FailureReasonChip[];
  onRemove: (code: string) => void;
};

const CriteriaList = ({
  screeningCriteriaMap,
  canEdit,
  isCorrectionLoading,
  isSaving,
  reasons,
  onRemove,
}: CriteriaListProps) => {
  if (isCorrectionLoading) {
    return <ZSpinner />;
  }

  return (
    <Stack
      useFlexGap
      direction="row"
      flexWrap="wrap"
      spacing={1}
    >
      {reasons.map((reason) => {
        const label = getFailureReasonLabel(reason.code, screeningCriteriaMap);
        const chip = (
          <Chip
            disabled={isSaving}
            label={(
              <Stack alignItems="center" direction="row" gap={0.5} pr={0.5}>
                {label}
                {reason.isAi && (
                  <Chip
                    label="AI"
                    size="small"
                    sx={{
                      backgroundColor: (theme) => theme.palette.common.gold50,
                      height: 16,
                      '& .MuiChip-label': {
                        fontWeight: 700,
                        px: 0.5,
                      },
                    }}
                  />
                )}
              </Stack>
            )}
            onDelete={canEdit ? () => onRemove(reason.code) : undefined}
            sx={{
              backgroundColor: (theme) => theme.palette.common.error10,
              cursor: 'default',
              pl: 0.5,
              pr: 0.5,
            }}
          />
        );

        if (!reason.tooltip) {
          return <span key={reason.code}>{chip}</span>;
        }

        return (
          <Tooltip key={reason.code} title={reason.tooltip}>
            <span>{chip}</span>
          </Tooltip>
        );
      })}
    </Stack>
  );
};

export default CriteriaList;
